import type { PublicBranch } from "../../../services/public";

export function getBranchFallbackCandidates(
  currentSlug: string | null | undefined,
  branches: PublicBranch[]
) {
  const normalizedCurrentSlug = String(currentSlug || "").trim();
  const seenSlugs = new Set<string>();
  const candidates: PublicBranch[] = [];

  for (const branch of Array.isArray(branches) ? branches : []) {
    const slug = String(branch.slug || "").trim();
    if (!slug || slug === normalizedCurrentSlug || seenSlugs.has(slug)) continue;

    seenSlugs.add(slug);
    candidates.push({ ...branch, slug });
  }

  return candidates;
}
